import { render } from "./DatadogHost.vue?vue&type=template&id=3f7383d2&scoped=true"
import script from "./DatadogHost.vue?vue&type=script&lang=js"
export * from "./DatadogHost.vue?vue&type=script&lang=js"

import "./DatadogHost.vue?vue&type=style&index=0&id=3f7383d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7383d2"]])

export default __exports__